import React from "react"
import { Button, Toast, ToastBody } from "reactstrap"

import Spinners from "components/Common/Spinner"

import close from "../../../assets/images/icons/close.svg"
import toast from "react-hot-toast"
import BgPatternImage from "../../../assets/images/background-pattern.png"

function RequestApproveConfirmationModal({
  id,
  open,
  setOpen,
  isLoading,
  title = "Approve KYC",
  description = "Are you sure you want to approve KYC?",
  onApprove,
  onSuccess,
  onClose,
}) {
  const handleSend = async () => {
    try {
      const { success, message } = await onApprove({ id }).unwrap()
      if (success) {
        onSuccess()
        onClose()
        toast.success(message, { id: "toastMessage" })
      }
    } catch (error) {
      console.error("Delete failed", error)
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }
  return (
    <>
      {open && <div className="toast-overlay" />}
      <div
        className="position-fixed top-0 start-50 translate-middle-x p-3"
        style={{ zIndex: "99999" }}
      >
        <Toast isOpen={open} role="alert" className="alert-card-box-wrapper">
          <div className="bg-pattern">
            <img src={BgPatternImage} alt="" />
          </div>
          <ToastBody>
            <div className="delete-card-wrapper">
              <div className="inner-box success">
                <i className="mdi mdi-check-circle-outline"></i>
              </div>
              <div>
                <h4>{title}</h4>
                {description}
              </div>
              <div className="close-icon" onClick={() => setOpen(false)}>
                <img src={close} alt="" />
              </div>
            </div>
            <div className="mt-3 pt-3 mb-0 button-wrapper buttons position-relative z-2">
              <button
                onClick={() => onClose()}
                type="button"
                className="cancel"
              >
                Cancel
              </button>
              <Button
                type="button"
                className="approve btn btn-secondary"
                onClick={handleSend}
              >
                {isLoading ? <Spinners /> : "Approve Updates"}
              </Button>
            </div>
          </ToastBody>
        </Toast>
      </div>
    </>
  )
}

export default RequestApproveConfirmationModal
